import { IApplicationState } from '../types/redux';

export function getGlobalErrorMessage(state: IApplicationState) {
  return state.globalError;
}
